<template>
  <td :class="bgClass">
    <b-button-group v-if="jaar - startjaar(mod) == 0 && mod.active">
      <b-button 
        variant="btn btn-primary btn-sm" 
        @click="mod.start--"
      >
        <i class="fa fa-plus" />
      </b-button>
      <b-button 
        variant="btn btn-primary btn-sm" 
        @click="mod.start++"
      >
        <i class="fa fa-minus" />
      </b-button>
    </b-button-group>

    <b-button 
      v-if="isMagnetJaar && mod.active" 
      variant="btn btn-primary btn-sm" 
      @click="mod.jaar--"
    >
      <i class="fa fa-step-backward" />
    </b-button>

    <i 
      v-if="isMagnetJaar" 
      :class="'fa fa-' + strengthIcon"
    />
    
    <b-button 
      v-if="isMagnetJaar && mod.active" 
      variant="btn btn-primary btn-sm" 
      @click="mod.jaar++"
    >
      <i class="fa fa-step-forward" />
    </b-button>

    <b-button-group v-if="jaar - eindjaar(mod) == 0 && mod.active">
      <b-button 
        variant="btn btn-primary btn-sm" 
        @click="mod.eind--"
      >
        <i class="fa fa-minus" />
      </b-button>
      <b-button 
        variant="btn btn-primary btn-sm" 
        @click="mod.eind++"
      >
        <i class="fa fa-plus" />
      </b-button>
    </b-button-group>
  </td>
</template>
<script>
import { magnetMixin } from "@/mixins/magnetMixin";
export default {
  name: "MagnetBlock",
  mixins: [
    magnetMixin
  ],
  props: {
    mod: {
      type: Object,
      required: true
    },
    jaar: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isMagnetJaar : function() {
        return this.jaar == this.mod.jaar;
    },
    strengthIcon: function() {
      var strength = this.strength(this.mod, this.jaar );
      if ( this.isMagnetJaar ) return "magnet";
      if ( strength == null ) return;
      if ( strength < 0 ) {
        return "long-arrow-left";
      } else {
        return "long-arrow-right";
      }
    },
    bgClass: function() {
      var strength = this.strength(this.mod, this.jaar );
      if (this.isMagnetJaar) return this.mod.active ? "bg-primary" : "bg-dark";
      if (strength == null) return;
      //if (strength == 0) return this.mod.active ? "bg-primary" : "bg-dark";
      if (strength < 0) {
        return this.mod.active ? "bg-info" : "bg-gray-" + strength * -100;
      } else {
        return this.mod.active ? "bg-info" : "bg-gray-" + strength * 100;
      }
    }
  }
};
</script>